module.exports = __webpack_public_path__ + "static/media/nynfc5.5c22ef62.jpg";